const normalizeBasePath = (value = '') => {
  const trimmed = value.trim();

  if (!trimmed || trimmed === '/') {
    return '';
  }

  return `/${trimmed.replace(/^\/+|\/+$/g, '')}`;
};

export const APP_BASENAME = normalizeBasePath(process.env.REACT_APP_BASENAME || '');

const DEFAULT_DEV_API_URL = 'http://localhost:8081/api';
const DEFAULT_PROD_API_URL = `${APP_BASENAME}/api` || '/api';

const resolveDefaultApiUrl = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_PROD_API_URL;
  }

  const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  return isLocalHost ? DEFAULT_DEV_API_URL : DEFAULT_PROD_API_URL;
};

export const API_URL = (process.env.REACT_APP_API_URL || resolveDefaultApiUrl())
  .trim()
  .replace(/\/$/, '');

export const API_ORIGIN = API_URL.replace(/\/api$/, '');

export const buildApiUrl = (path = '') => {
  if (!path) return API_URL;
  return `${API_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const buildAssetUrl = (path?: string | null) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  if (!path.startsWith('/') && !path.startsWith('uploads/')) {
    return `${API_URL}/books/covers/${path}`;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_ORIGIN}${normalizedPath}`;
};

export const getPlaceholderImage = (
  title: string,
  width: number,
  height: number,
  background = '#4F46E5',
  foreground = '#FFFFFF'
) => {
  const safeTitle = (title || 'Biblioteca Digitala')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const fontSize = Math.max(16, Math.round(width / 10));
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect width="100%" height="100%" fill="${background}" />
      <text
        x="50%"
        y="50%"
        fill="${foreground}"
        font-family="Arial, sans-serif"
        font-size="${fontSize}"
        font-weight="700"
        text-anchor="middle"
        dominant-baseline="middle"
      >${safeTitle}</text>
    </svg>
  `.replace(/\s+/g, ' ').trim();

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
